import { render, staticRenderFns } from "./KeyRegistrationModal.vue?vue&type=template&id=706694f4&scoped=true"
import script from "./KeyRegistrationModal.vue?vue&type=script&lang=js"
export * from "./KeyRegistrationModal.vue?vue&type=script&lang=js"
import style0 from "./KeyRegistrationModal.vue?vue&type=style&index=0&id=706694f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706694f4",
  null
  
)

export default component.exports